import { HTMLAttributes } from 'react'
import cl from 'classnames'

const InfoCardValue = ({
  className,
  ...rest
}: HTMLAttributes<HTMLParagraphElement>) => {
  return (
    <p
      className={cl(
        'text-lg leading-6 text-v3-gray-425 font-bold tracking-wide lg:text-xl lg:leading-none xl:text-[19.831px] xl:leading-[20.754px] 1.5xl:text-xl 1.5xl:leading-none',
        className
      )}
      {...rest}
    />
  )
}

export const Value = InfoCardValue
